import {
  useNavigate as useReactRouterNavigate,
  NavigateOptions,
} from "react-router-dom";
import { useRoutes } from "@Libs/Router/hooks/useRoutes";
import {
  IGenerateRouteKey,
  IGenerateRouteParams,
  IGenerateRouteQueryParams,
} from "@Libs/Router/Contexts/RoutesContext";
import { useLocation } from "./useLocation";

export interface UseNavigateOptions extends NavigateOptions {
  reload?: boolean;
  params?: IGenerateRouteParams;
  queryParams?: IGenerateRouteQueryParams;
  replace?: boolean;
  append?: boolean;
  back?: boolean;
}

export const useNavigate = () => {
  const routerNavigate = useReactRouterNavigate();
  const { generateRoute } = useRoutes();
  const { pathname } = useLocation();

  const navigate = (
    to: IGenerateRouteKey,
    options?: UseNavigateOptions
  ): void => {
    if (options?.back) {
      routerNavigate(-1);
      return;
    }

    let url = generateRoute(to, options?.params, options?.queryParams);

    if (options?.append) {
      url = pathname + url;
    }

    if (options?.reload) {
      routerNavigate(url, options);
      window.location.reload();
    } else {
      routerNavigate(url, options);
    }
  };

  return navigate;
};
